import React from "react";

import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Row, Col } from "react-bootstrap";

import { NavLink } from "react-router-dom";

import { FaFacebookF, FaInstagram, FaPinterest, FaTwitter, FaYoutube, FaCheck, FaSketch, FaOpencart } from "react-icons/fa";
import { BsSendCheck, BsFill1CircleFill, BsFill2CircleFill, BsFill3CircleFill, BsFill4CircleFill, BsFill5CircleFill, BsCheckLg, BsFillPatchCheckFill } from "react-icons/bs";



function AboutUs() {

    return (

        <Container>

            <br/>

            <h3><strong><BsFillPatchCheckFill/> เกี่ยวกับเรา</strong></h3>
       
            <h3 className="pb-3 border-bottom"></h3>
            <br/>

            <h5 style={{marginTop: 5}}>ประมวลกฎหมาย และหนังสือกฎหมาย ฉบับ EBOOK ใช้งานได้ในอุปกรณ์ระบบ ios ได้แก่ iPad และ iPhone ผ่านแอพพลิเคชั่น EduLaw ใช้งานได้ทุกที่ทุกเวลาทั้งในโหมดออนไลน์และออฟไลน์</h5>


            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            

        </Container>

    );

}

export default AboutUs;